import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import { ActiveRiskToggleIcon, ActiveRecognizeToggleIcon } from './Icons'

const useStyles = makeStyles({
  newToggleGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  toggleItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: 12,
    cursor: 'pointer',
  },
  toggleIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  toggleTitle: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 400,
    marginLeft: 8,
  },
})

interface TwoValuesToggleProps {
  textOption1?: any
  textOption2?: any
  toggleObj?: any
  setToggleObj?: any
}

const TwoValuesToggle = ({
  textOption1,
  textOption2,
  toggleObj,
  setToggleObj,
}: TwoValuesToggleProps) => {
  const classes = useStyles()
  const [toggleData, setToggleData] = useState({
    unrecognisedRiskStatusValue: true,
    riskEventsValue: false,
  })

  useEffect(() => {
    if (toggleObj) {
      setToggleData({
        unrecognisedRiskStatusValue: toggleObj.showUnrecognisedRiskStatus,
        riskEventsValue: toggleObj.showRiskEvents,
      })
    }
  }, [toggleObj])

  const onToggleItem = () => {
    const cloned = JSON.parse(JSON.stringify(toggleData))
    cloned.unrecognisedRiskStatusValue = !cloned.unrecognisedRiskStatusValue
    cloned.riskEventsValue = !cloned.riskEventsValue
    setToggleObj({
      showUnrecognisedRiskStatus: cloned.unrecognisedRiskStatusValue,
      showRiskEvents: cloned.riskEventsValue,
    })
    setToggleData(cloned)
  }

  return (
    <div
      className={classes.newToggleGroup}
      style={{
        justifyContent: 'flex-start',
        marginTop: 0,
      }}
    >
      <div onClick={() => onToggleItem()} className={classes.toggleItem}>
        <div
          className={classes.toggleTitle}
          style={{
            color: toggleData.unrecognisedRiskStatusValue
              ? '#1B3963'
              : '#A3A3A3',
            fontSize: isMobile ? 10 : 12,
          }}
        >
          {textOption1}
        </div>
      </div>

      <div onClick={() => onToggleItem()} className={classes.toggleItem}>
        <div className={classes.toggleIcon}>
          {toggleData.riskEventsValue ? (
            <ActiveRiskToggleIcon />
          ) : (
            <ActiveRecognizeToggleIcon />
          )}
        </div>
        <div
          className={classes.toggleTitle}
          style={{
            fontSize: isMobile ? 10 : 12,
            color: toggleData.riskEventsValue ? '#1B3963' : '#A3A3A3',
          }}
        >
          {textOption2}
        </div>
      </div>
    </div>
  )
}

export default TwoValuesToggle
